import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import type { ActionContext } from 'js/lib/ActionContext';

export const withFluxibleContextAsProps =
  <P extends ActionContext>() =>
  (WrappedComponent: React.ComponentType<P>) => {
    return class Wrapper extends React.Component<P> {
      static displayName = `withFluxibleContextAsProps(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
      })`;

      static contextTypes = {
        executeAction: PropTypes.func,
        getStore: PropTypes.func,
      };

      declare context: LegacyContextType<typeof Wrapper.contextTypes>;

      render() {
        return (
          <WrappedComponent
            {...this.props}
            executeAction={this.context.executeAction}
            getStore={this.context.getStore}
          />
        );
      }
    };
  };

export default withFluxibleContextAsProps;
